if (!window.globalThis) {
  window.globalThis = window;
}
